import React from 'react';
export function ErrorCredentials() {
  	return (
    	<div>
      		<p>Tiene un error con la credenciales</p>
    	</div>
  	);
}